import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/useUserServicePatchHook";
import useGetHook from "../../customHooks/useUserServiceGetHook";

const UpdateRoleComponent = loadable(
  () => import("../../components/Auth/UpdateRole")
);
const UpdateRole = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`role-${id}`],
    url: `${APIS.GROUP}${id}/`,
    params: {},
  });

  const { data: userPermissions } = useGetHook({
    queryKey: [`userPermissions`],
    url: `${APIS.PERMISSIONS}user_management/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["roles"],
    navigateURL: "/roles",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.GROUP}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Role</span>
      </div>
      <UpdateRoleComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
        userPermissions={userPermissions}
      />
    </>
  );
};

export default UpdateRole